import { RecommendedAsinsV2 } from './recommended-asins-v2';

export { RecommendedAsinsV2 };
